/* El ciclo del PLA, versión «ciencia»: líneas limpias, zoom y átomos con su letra.

   1. El llavero            4. Los mismos átomos, recolocados en CO2 y agua
   2. Zoom: la cadena       5. La planta los toma, hace azúcar y vuelta a empezar
   3. El agua la corta

   Los átomos están contados: cada unidad de la cadena es C3H4O2, con una
   molécula de agua pasa a ácido láctico (C3H6O3), y con tres de oxígeno da
   3 CO2 + 3 H2O. No aparece ni desaparece ninguno.

   Igual que ciclo.js, todo sale de frame(t, oscuro): un SVG por instante. */
(function (raiz) {
  'use strict';

  var W = 800, H = 600, T = 24;

  // Los dibujos de Sebas (objetos/dia y objetos/noche), montados por objetos/montar.py.
  var OBJ = typeof module !== 'undefined' && module.exports ? require('./objetos.js') : raiz.SugarObjetos;
  /* Coloca un objeto con el punto (ax, ay) de su lienzo en (x, y), a escala e. */
  function pieza(modo, nombre, x, y, ax, ay, e, alfa) {
    if (alfa !== undefined && alfa <= 0.02) return '';
    var o = OBJ[modo][nombre];
    return '<g transform="translate(' + r1(x - ax * e) + ' ' + r1(y - ay * e) + ') scale(' + (Math.round(e * 1000) / 1000) + ')"' +
      (alfa !== undefined && alfa < 1 ? ' opacity="' + (Math.round(alfa * 100) / 100) + '"' : '') + '>' + o.svg + '</g>';
  }

  function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function ease(x) { x = cl(x); return x * x * (3 - 2 * x); }
  function lerp(a, b, k) { return a + (b - a) * k; }
  function mix(p, q, k) { return { x: lerp(p.x, q.x, k), y: lerp(p.y, q.y, k) }; }
  function r1(x) { return Math.round(x * 10) / 10; }
  function entre(t, a, b) { return ease((t - a) / (b - a)); }

  var PALETAS = {
    dia: { modo: 'dia', fondo: '#fbf9f6', tinta: '#1d1d1f', gris: '#6b665f', linea: '#c9c2b8', enlace: '#8a8f99',
           C: '#3a3f4b', O: '#e8546b', Hh: '#e3e9f0', letraH: '#3a3f4b', acento: '#2c979b', coral: '#cf4560',
           llavero: '#bfe6d6', hoja: '#7fc39e', sol: '#f6c95a', azucar: '#f6e3a8', chip: '#ffffff' },
    noche: { modo: 'noche', fondo: '#181622', tinta: '#f6f1ea', gris: '#b6b0c6', linea: '#3b3650', enlace: '#7d7896',
             C: '#59607a', O: '#ff7088', Hh: '#dfe6f2', letraH: '#262233', acento: '#6fd6d2', coral: '#ff8ea3',
             llavero: '#3f8f7c', hoja: '#5fb596', sol: '#e6c066', azucar: '#c9a94e', chip: '#262233' }
  };
  var LETRA = "-apple-system,'Helvetica Neue',Arial,sans-serif";

  var PASOS = [
    [0, 'El llavero', 'Un llavero de PLA, visto cada vez más de cerca'],
    [4, 'Muy de cerca', 'Es una cadena: la misma pieza repetida miles de veces'],
    [9, 'El agua la corta', 'Al descomponerse, el agua separa la cadena pieza a pieza'],
    [14, 'Los mismos átomos', 'Con oxígeno, cada pieza se recoloca en CO₂ y agua. No se pierde ni un átomo'],
    [19.5, 'Vuelta a empezar', 'Una planta los toma, hace azúcar, y del azúcar sale otra vez el PLA']
  ];

  // ---------- geometría de la cadena ----------
  var PASO = 172, X0 = 62, YC = 290;
  function unidad(j) {                 // átomos de una pieza, en la cadena
    var s = j % 2 ? -1 : 1, x = X0 + j * PASO;
    var Cm = { x: x + 40, y: YC - s * 82 };
    return {
      s: s,
      Oe: { x: x, y: YC + s * 18 },
      Ca: { x: x + 56, y: YC - s * 18 },
      Cc: { x: x + 112, y: YC + s * 18 },
      Od: { x: x + 112, y: YC + s * 82 },
      Cm: Cm,
      Ha: { x: x + 92, y: YC - s * 58 },
      H1: { x: Cm.x - 28, y: Cm.y + s * 4 },
      H2: { x: Cm.x - 6, y: Cm.y - s * 28 },
      H3: { x: Cm.x + 26, y: Cm.y - s * 10 }
    };
  }
  var NU = 4;

  // ---------- lienzo ----------
  function Lienzo(p) {
    var s = [];
    function at(o) { var t = ''; for (var k in o) if (o[k] !== undefined && o[k] !== null) t += ' ' + k + '="' + o[k] + '"'; return t; }
    var L = {
      s: s,
      crudo: function (t) { s.push(t); },
      el: function (n, o, dentro) { s.push('<' + n + at(o) + (dentro === undefined ? '/>' : '>' + dentro + '</' + n + '>')); },
      texto: function (x, y, t, o) { L.el('text', Object.assign({ x: r1(x), y: r1(y), 'font-family': LETRA }, o), t); },
      enlace: function (a, b, alfa, doble, e) {
        if (alfa <= 0.02) return;
        e = e || 1;
        var o = { stroke: p.enlace, 'stroke-width': r1(3.2 * e), 'stroke-linecap': 'round', opacity: alfa < 1 ? r1(alfa * 10) / 10 : undefined };
        if (!doble) { L.el('line', Object.assign({ x1: r1(a.x), y1: r1(a.y), x2: r1(b.x), y2: r1(b.y) }, o)); return; }
        var dx = b.x - a.x, dy = b.y - a.y, n = Math.sqrt(dx * dx + dy * dy) || 1, ox = -dy / n * 3.6 * e, oy = dx / n * 3.6 * e;
        L.el('line', Object.assign({ x1: r1(a.x + ox), y1: r1(a.y + oy), x2: r1(b.x + ox), y2: r1(b.y + oy) }, o));
        L.el('line', Object.assign({ x1: r1(a.x - ox), y1: r1(a.y - oy), x2: r1(b.x - ox), y2: r1(b.y - oy) }, o));
      },
      atomo: function (pos, tipo, alfa, e) {
        if (alfa <= 0.02) return;
        s.push(pieza(p.modo, 'atomo-' + tipo.toLowerCase(), pos.x, pos.y, 20, 20, e || 1, alfa));
      }
    };
    return L;
  }

  // ---------- el llavero ----------
  function media(y) {
    if (y < 0.34) return lerp(0.36, 1, ease(y / 0.34));
    return lerp(1, 0.42, Math.pow((y - 0.34) / 0.66, 1.05));
  }
  function llavero(L, p, cx, cy, alto, alfa) {
    if (alfa <= 0.02) return;
    // El dibujo ocupa casi todo su lienzo de 220 x 400; `alto` es el tamaño de referencia de la escena.
    L.crudo(pieza(p.modo, 'llavero', cx, cy, 110, 200, alto / 330 * 0.95, alfa));
  }

  function flecha(L, p, a, c, b, k, alfa) {          // flecha curva que se va dibujando
    if (alfa <= 0.02 || k <= 0.01) return;
    var pts = [], n = 24, i;
    for (i = 0; i <= Math.round(n * k); i++) {
      var u = i / n, m = 1 - u;
      pts.push({ x: m * m * a.x + 2 * m * u * c.x + u * u * b.x, y: m * m * a.y + 2 * m * u * c.y + u * u * b.y });
    }
    if (pts.length < 2) return;
    var d = pts.map(function (q, n2) { return (n2 ? 'L' : 'M') + r1(q.x) + ' ' + r1(q.y); }).join('');
    var u1 = pts[pts.length - 1], u0 = pts[pts.length - 2], an = Math.atan2(u1.y - u0.y, u1.x - u0.x);
    L.el('path', { d: d, fill: 'none', stroke: p.acento, 'stroke-width': 3, 'stroke-linecap': 'round', opacity: r1(alfa * 10) / 10 });
    L.el('path', {
      d: 'M' + r1(u1.x + Math.cos(an) * 6) + ' ' + r1(u1.y + Math.sin(an) * 6) + 'L' + r1(u1.x + Math.cos(an + 2.5) * 11) + ' ' + r1(u1.y + Math.sin(an + 2.5) * 11) + 'L' + r1(u1.x + Math.cos(an - 2.5) * 11) + ' ' + r1(u1.y + Math.sin(an - 2.5) * 11) + 'Z',
      fill: p.acento, opacity: r1(alfa * 10) / 10
    });
  }

  // ---------- escenas 2 y 3: la cadena y el agua ----------
  function cadena(L, p, t, alfaGlobal) {
    if (alfaGlobal <= 0.02) return;
    var k, j;
    // cuánto se ha separado cada pieza, y cuánto se ha roto cada enlace
    var abre = entre(t, 11.9, 13.2);
    function sitio(j) {
      var u = unidad(j), dx = (j - 1.5) * 10 * abre, dy = (j % 2 ? 26 : -26) * abre, o = { s: u.s };
      for (var n in u) if (n !== 's') o[n] = { x: u[n].x + dx, y: u[n].y + dy };
      return o;
    }
    var U = []; for (j = 0; j < NU; j++) U.push(sitio(j));
    function rompe(b) { return entre(t, 10.7 + b * 0.18, 11.6 + b * 0.18); }   // enlace b: entre la pieza b-1 y la b

    L.crudo('<g opacity="' + r1(alfaGlobal * 100) / 100 + '">');
    // los extremos: la cadena sigue
    var seguir = 1 - rompe(0);
    L.el('line', { x1: 14, y1: r1(U[0].Oe.y - 14), x2: r1(U[0].Oe.x), y2: r1(U[0].Oe.y), stroke: p.enlace, 'stroke-width': 3.2, 'stroke-dasharray': '2 8', 'stroke-linecap': 'round', opacity: r1(seguir * 10) / 10 });
    L.el('line', { x1: r1(U[3].Cc.x), y1: r1(U[3].Cc.y), x2: 786, y2: r1(U[3].Cc.y + 14), stroke: p.enlace, 'stroke-width': 3.2, 'stroke-dasharray': '2 8', 'stroke-linecap': 'round', opacity: r1((1 - rompe(4)) * 10) / 10 });

    // enlaces dentro de cada pieza y entre piezas
    for (j = 0; j < NU; j++) {
      var u = U[j];
      L.enlace(u.Oe, u.Ca, 1); L.enlace(u.Ca, u.Cc, 1); L.enlace(u.Cc, u.Od, 1, true);
      L.enlace(u.Ca, u.Cm, 1); L.enlace(u.Ca, u.Ha, 1);
      L.enlace(u.Cm, u.H1, 1); L.enlace(u.Cm, u.H2, 1); L.enlace(u.Cm, u.H3, 1);
      if (j < NU - 1) L.enlace(u.Cc, U[j + 1].Oe, 1 - rompe(j + 1));
    }

    // las moléculas de agua: bajan, cortan y se reparten
    var aguas = [];
    for (var b = 0; b <= NU; b++) {
      var izq = b > 0 ? U[b - 1] : null, der = b < NU ? U[b] : null;
      var medio = izq && der ? mix(izq.Cc, der.Oe, 0.5) : (der ? { x: der.Oe.x - 34, y: der.Oe.y } : { x: izq.Cc.x + 34, y: izq.Cc.y });
      var s = der ? der.s : -izq.s;                       // hacia qué lado queda libre
      var espera = { x: medio.x, y: medio.y - s * 64 };
      var baja = entre(t, 9.2 + b * 0.22, 10.5 + b * 0.22), r = rompe(b);
      var O0 = mix({ x: espera.x, y: s > 0 ? -40 : H + 40 }, espera, baja);
      var Ha0 = { x: O0.x - 20, y: O0.y - s * 17 }, Hb0 = { x: O0.x + 20, y: O0.y - s * 17 };
      // destinos: el OH al carbono de la izquierda, el H al oxígeno de la derecha
      var Of = izq ? { x: izq.Cc.x + 44, y: izq.Cc.y - izq.s * 30 } : { x: -70, y: O0.y };
      var Haf = izq ? { x: Of.x + 22, y: Of.y - izq.s * 16 } : { x: -90, y: O0.y - 14 };
      var Hbf = der ? { x: der.Oe.x - 24, y: der.Oe.y + der.s * 20 } : { x: W + 70, y: O0.y };
      var O = mix(O0, Of, r), Ha = mix(Ha0, Haf, r), Hb = mix(Hb0, Hbf, r);
      var a = baja > 0 ? 1 : 0;
      if (a) {
        L.enlace(O, Ha, 1);
        L.enlace(O, Hb, 1 - cl(r * 2));
        if (izq) L.enlace(izq.Cc, O, cl(r * 2 - 1));
        if (der) L.enlace(der.Oe, Hb, cl(r * 2 - 1));
        aguas.push([O, 'O'], [Ha, 'H'], [Hb, 'H']);
      }
    }

    // los átomos, encima de los enlaces
    for (j = 0; j < NU; j++) {
      var q = U[j];
      L.atomo(q.H1, 'H', 1); L.atomo(q.H2, 'H', 1); L.atomo(q.H3, 'H', 1); L.atomo(q.Ha, 'H', 1);
      L.atomo(q.Cm, 'C', 1); L.atomo(q.Od, 'O', 1);
      L.atomo(q.Oe, 'O', 1); L.atomo(q.Ca, 'C', 1); L.atomo(q.Cc, 'C', 1);
    }
    aguas.forEach(function (w) { L.atomo(w[0], w[1], 1); });

    // el corchete de «una pieza» y los rótulos
    var rot = entre(t, 4.6, 5.4) * (1 - entre(t, 8.6, 9.2));
    if (rot > 0.02) {
      var a1 = U[1].Oe.x - 22, a2 = U[1].Cc.x + 22, yb = YC + 128;
      L.el('path', { d: 'M' + a1 + ' ' + (yb - 10) + 'V' + yb + 'H' + a2 + 'V' + (yb - 10), fill: 'none', stroke: p.coral, 'stroke-width': 2.5, 'stroke-linecap': 'round', 'stroke-linejoin': 'round', opacity: r1(rot * 10) / 10 });
      L.texto((a1 + a2) / 2, yb + 24, 'una pieza', { 'text-anchor': 'middle', 'font-size': 16, 'font-weight': 700, fill: p.coral, opacity: r1(rot * 10) / 10 });
      L.texto(W / 2, 118, '… × miles …', { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.gris, opacity: r1(rot * 10) / 10 });
    }
    var rotAgua = entre(t, 9.4, 10) * (1 - entre(t, 11.2, 11.8));
    if (rotAgua > 0.02) L.texto(W / 2, 118, 'agua (H₂O)', { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.acento, opacity: r1(rotAgua * 10) / 10 });
    var rotAcido = entre(t, 12.6, 13.2);
    if (rotAcido > 0.02) L.texto(W / 2, 118, 'cada pieza suelta es ácido láctico', { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.gris, opacity: r1(rotAcido * 10) / 10 });
    L.crudo('</g>');
  }

  // ---------- escena 4: los mismos átomos, recolocados ----------
  function recoloca(L, p, t, alfaGlobal) {
    if (alfaGlobal <= 0.02) return;
    var E = 1.3, centro = { x: 400, y: 285 };
    // la pieza 1 tal como quedó al final de la escena 3, ya como ácido láctico
    var u0 = unidad(1), dx = (1 - 1.5) * 10, dy = 26, n;
    var A = {}; for (n in u0) if (n !== 's') A[n] = { x: u0[n].x + dx, y: u0[n].y + dy };
    A.Ow = { x: A.Cc.x + 44, y: A.Cc.y - u0.s * 30 };
    A.Hw = { x: A.Ow.x + 22, y: A.Ow.y - u0.s * 16 };
    A.Hb = { x: A.Oe.x - 24, y: A.Oe.y + u0.s * 20 };
    var cx = (A.Oe.x + A.Cc.x) / 2, cy = YC + dy;
    var acerca = entre(t, 14, 15.2);
    function mol(q) {                   // la molécula, acercándose al centro y creciendo
      var e = lerp(1, E, acerca);
      return { x: lerp(q.x, centro.x + (q.x - cx) * E, acerca), y: lerp(q.y, centro.y + (q.y - cy) * E, acerca), e: e };
    }
    // el oxígeno que llega: tres parejas
    var llega = entre(t, 15.2, 16.2);
    var O2 = [[150, 150], [650, 150], [400, 470]].map(function (c, i) {
      var desde = [{ x: -60, y: 60 }, { x: W + 60, y: 60 }, { x: 400, y: H + 60 }][i];
      var pos = mix(desde, { x: c[0], y: c[1] }, llega);
      return [{ x: pos.x - 15 * E, y: pos.y }, { x: pos.x + 15 * E, y: pos.y }];
    });
    // los destinos: tres CO2 arriba y tres de agua abajo
    var xs = [215, 400, 585], yCO2 = 205, yH2O = 395, sep = 37 * E * 0.8;
    var destino = {
      Ca: { x: xs[0], y: yCO2 }, Cc: { x: xs[1], y: yCO2 }, Cm: { x: xs[2], y: yCO2 },
      Oe: { x: xs[0], y: yH2O }, Od: { x: xs[1], y: yH2O }, Ow: { x: xs[2], y: yH2O },
      Hb: { x: xs[0] - 24, y: yH2O + 22 }, Ha: { x: xs[0] + 24, y: yH2O + 22 },
      H1: { x: xs[1] - 24, y: yH2O + 22 }, H2: { x: xs[1] + 24, y: yH2O + 22 },
      H3: { x: xs[2] - 24, y: yH2O + 22 }, Hw: { x: xs[2] + 24, y: yH2O + 22 }
    };
    var destinoO2 = [[{ x: xs[0] - sep, y: yCO2 }, { x: xs[0] + sep, y: yCO2 }],
                     [{ x: xs[2] - sep, y: yCO2 }, { x: xs[2] + sep, y: yCO2 }],
                     [{ x: xs[1] - sep, y: yCO2 }, { x: xs[1] + sep, y: yCO2 }]];
    var orden = ['Ca', 'Cc', 'Cm', 'Oe', 'Od', 'Ow', 'Hb', 'Ha', 'H1', 'H2', 'H3', 'Hw'];
    function mueve(i) { return entre(t, 16.3 + i * 0.07, 17.7 + i * 0.07); }
    var P = {};
    orden.forEach(function (nom, i) { var m = mol(A[nom]); P[nom] = mix(m, destino[nom], mueve(i)); });
    var PO = O2.map(function (par, i) { return [mix(par[0], destinoO2[i][0], mueve(12 + i * 2)), mix(par[1], destinoO2[i][1], mueve(13 + i * 2))]; });
    var e = lerp(1, E, acerca);
    var viejo = 1 - entre(t, 16.2, 16.8), nuevo = entre(t, 18.0, 18.5);

    L.crudo('<g opacity="' + r1(alfaGlobal * 100) / 100 + '">');
    // enlaces del ácido láctico y del oxígeno, que se sueltan
    [['Oe', 'Ca'], ['Ca', 'Cc'], ['Ca', 'Cm'], ['Ca', 'Ha'], ['Cm', 'H1'], ['Cm', 'H2'], ['Cm', 'H3'], ['Cc', 'Ow'], ['Ow', 'Hw'], ['Oe', 'Hb']].forEach(function (b) { L.enlace(P[b[0]], P[b[1]], viejo, false, e); });
    L.enlace(P.Cc, P.Od, viejo, true, e);
    PO.forEach(function (par) { L.enlace(par[0], par[1], viejo * llega, true, E); });
    // enlaces nuevos
    [['Ca', 0], ['Cm', 1], ['Cc', 2]].forEach(function (c) { L.enlace(P[c[0]], PO[c[1]][0], nuevo, true, E); L.enlace(P[c[0]], PO[c[1]][1], nuevo, true, E); });
    [['Oe', 'Hb', 'Ha'], ['Od', 'H1', 'H2'], ['Ow', 'H3', 'Hw']].forEach(function (w) { L.enlace(P[w[0]], P[w[1]], nuevo, false, E); L.enlace(P[w[0]], P[w[2]], nuevo, false, E); });
    // átomos
    ['Hb', 'Ha', 'H1', 'H2', 'H3', 'Hw'].forEach(function (nom) { L.atomo(P[nom], 'H', 1, e); });
    ['Oe', 'Od', 'Ow'].forEach(function (nom) { L.atomo(P[nom], 'O', 1, e); });
    PO.forEach(function (par) { L.atomo(par[0], 'O', llega, E); L.atomo(par[1], 'O', llega, E); });
    ['Ca', 'Cc', 'Cm'].forEach(function (nom) { L.atomo(P[nom], 'C', 1, e); });

    // rótulos
    var antes = entre(t, 15.3, 16) * (1 - entre(t, 16.4, 17));
    if (antes > 0.02) L.texto(W / 2, 96, 'ácido láctico + oxígeno (O₂)', { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.gris, opacity: r1(antes * 10) / 10 });
    if (nuevo > 0.02) {
      L.texto(W / 2, 96, '3 C · 6 H · 9 O antes, 3 C · 6 H · 9 O después', { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.gris, opacity: r1(nuevo * 10) / 10 });
      L.texto(xs[1], yCO2 - 46, 'CO₂', { 'text-anchor': 'middle', 'font-size': 17, 'font-weight': 700, fill: p.coral, opacity: r1(nuevo * 10) / 10 });
      L.texto(xs[1], yH2O + 62, 'agua (H₂O)', { 'text-anchor': 'middle', 'font-size': 17, 'font-weight': 700, fill: p.acento, opacity: r1(nuevo * 10) / 10 });
    }
    L.crudo('</g>');
  }

  // ---------- escena 5: el ciclo entero ----------
  function ciclo(L, p, t, alfaGlobal, llaveroAparte) {
    if (alfaGlobal <= 0.02) return;
    var N1 = { x: 165, y: 285 }, N2 = { x: 400, y: 455 }, N3 = { x: 635, y: 285 }, N4 = { x: 400, y: 120 };
    L.crudo('<g opacity="' + r1(alfaGlobal * 100) / 100 + '">');
    // flechas, una detrás de otra
    flecha(L, p, { x: 205, y: 370 }, { x: 250, y: 450 }, { x: 330, y: 455 }, entre(t, 20.2, 20.9), 1);
    flecha(L, p, { x: 470, y: 455 }, { x: 540, y: 452 }, { x: 574, y: 384 }, entre(t, 20.9, 21.6), 1);
    flecha(L, p, { x: 600, y: 200 }, { x: 560, y: 125 }, { x: 470, y: 120 }, entre(t, 21.6, 22.3), 1);
    flecha(L, p, { x: 330, y: 120 }, { x: 250, y: 125 }, { x: 205, y: 195 }, entre(t, 22.3, 23), 1);

    // abajo: agua y CO2
    var a2 = entre(t, 20, 20.6);
    L.crudo('<g opacity="' + r1(a2 * 10) / 10 + '">');
    var c1 = { x: N2.x - 36, y: N2.y - 6 }, e = 0.72;
    L.enlace({ x: c1.x - 20, y: c1.y }, { x: c1.x + 20, y: c1.y }, 1, true, e);
    L.atomo({ x: c1.x - 20, y: c1.y }, 'O', 1, e); L.atomo({ x: c1.x + 20, y: c1.y }, 'O', 1, e); L.atomo(c1, 'C', 1, e);
    var w1 = { x: N2.x + 36, y: N2.y - 10 };
    L.enlace(w1, { x: w1.x - 14, y: w1.y + 13 }, 1, false, e); L.enlace(w1, { x: w1.x + 14, y: w1.y + 13 }, 1, false, e);
    L.atomo({ x: w1.x - 14, y: w1.y + 13 }, 'H', 1, e); L.atomo({ x: w1.x + 14, y: w1.y + 13 }, 'H', 1, e); L.atomo(w1, 'O', 1, e);
    L.texto(N2.x, N2.y + 40, 'CO₂ y agua', { 'text-anchor': 'middle', 'font-size': 16, 'font-weight': 700, fill: p.tinta });
    L.crudo('</g>');

    // derecha: la planta y el sol
    var a3 = entre(t, 20.7, 21.3);
    L.crudo('<g opacity="' + r1(a3 * 10) / 10 + '">');
    L.crudo(pieza(p.modo, 'planta', N3.x, N3.y, 80, 100, 1));
    L.crudo(pieza(p.modo, 'sol', N3.x + 72, N3.y - 92, 40, 40, 0.9));
    L.texto(N3.x + 14, N3.y + 96, 'una planta', { 'text-anchor': 'middle', 'font-size': 16, 'font-weight': 700, fill: p.tinta });
    L.crudo('</g>');

    // arriba: el azúcar
    var a4 = entre(t, 21.4, 22);
    L.crudo('<g opacity="' + r1(a4 * 10) / 10 + '">');
    L.crudo(pieza(p.modo, 'azucar', N4.x, N4.y - 8, 40, 40, 1));
    L.texto(N4.x, N4.y + 46, 'azúcar', { 'text-anchor': 'middle', 'font-size': 16, 'font-weight': 700, fill: p.tinta });
    L.crudo('</g>');

    // izquierda: el rótulo del llavero (el llavero lo dibuja frame, para que cierre el bucle)
    var a1 = entre(t, 19.8, 20.4);
    L.texto(N1.x, N1.y + 108, 'PLA', { 'text-anchor': 'middle', 'font-size': 16, 'font-weight': 700, fill: p.tinta, opacity: r1(a1 * 10) / 10 });
    L.crudo('</g>');
  }

  // ---------- un fotograma ----------
  /* `limpio` quita el rótulo del paso, la frase y los puntos: para cuando el texto lo pone la página. */
  function frame(t, oscuro, limpio) {
    t = ((t % T) + T) % T;
    var p = oscuro ? PALETAS.noche : PALETAS.dia;
    var L = Lienzo(p), i;
    L.el('rect', { width: W, height: H, fill: p.fondo });
    // una retícula de puntos, muy suave
    var pts = '';
    for (var gx = 40; gx < W; gx += 40) for (var gy = 40; gy < (limpio ? H : H - 60); gy += 40) pts += 'M' + gx + ' ' + gy + 'h.01';
    L.el('path', { d: pts, stroke: p.linea, 'stroke-width': 2.4, 'stroke-linecap': 'round', fill: 'none' });

    // escena 1: el llavero, y la lupa que se abre
    var lupa = entre(t, 2.6, 4.2);
    var llaveroGrande = 1 - entre(t, 3.4, 4.2);
    if (t < 4.3) {
      llavero(L, p, 400, 290, 330, llaveroGrande);
      var marca = entre(t, 1.4, 2) * (1 - entre(t, 3.6, 4.2));
      if (marca > 0.02) {
        var rl = lerp(30, 560, lupa * lupa);
        // el fondo de la escena siguiente, que se abre dentro del cristal
        L.el('circle', { cx: 400, cy: 330, r: r1(rl), fill: p.fondo, opacity: r1(marca * lupa * 10) / 10 });
        L.crudo(pieza(p.modo, 'lupa', 400, 330, 40, 40, rl / 30, marca * (1 - lupa * 0.6)));
        if (lupa < 0.4) L.texto(476, 416, 'zoom', { 'font-size': 17, 'font-weight': 700, fill: p.coral, opacity: r1(marca * (1 - lupa * 2.5) * 10) / 10 });
      }
    }

    // escenas 2 y 3
    cadena(L, p, t, entre(t, 3.5, 4.3) * (1 - entre(t, 13.9, 14.3) * (t > 13 ? 1 : 0)));
    // escena 4 (arranca justo donde acaba la 3, con la pieza 1 en el mismo sitio)
    if (t >= 13.9) recoloca(L, p, t, entre(t, 13.9, 14.3) * (1 - entre(t, 19.4, 20.1)));
    // escena 5
    if (t >= 19.4) {
      var fuera = entre(t, 23, 23.8);
      ciclo(L, p, t, entre(t, 19.6, 20.2) * (1 - fuera));
      // el llavero pequeño de la izquierda crece hasta el del principio: el bucle cierra
      var k = entre(t, 23, 24);
      llavero(L, p, lerp(165, 400, k), lerp(285, 290, k), lerp(130, 330, k), entre(t, 19.8, 20.4));
    }

    // el paso, arriba a la izquierda, y la frase, abajo
    for (i = 0; !limpio && i < PASOS.length; i++) {
      var ini = PASOS[i][0], fin = i + 1 < PASOS.length ? PASOS[i + 1][0] : T;
      var op = Math.min(cl((t - ini) / 0.45), cl((fin - t) / 0.45));
      if (op <= 0.02) continue;
      var o = r1(op * 10) / 10;
      L.crudo('<g opacity="' + o + '">');
      L.el('circle', { cx: 44, cy: 44, r: 17, fill: p.acento });
      L.texto(44, 50, String(i + 1), { 'text-anchor': 'middle', 'font-size': 17, 'font-weight': 800, fill: '#fff' });
      L.texto(72, 50, PASOS[i][1], { 'font-size': 18, 'font-weight': 700, fill: p.tinta });
      L.texto(W / 2, H - 26, PASOS[i][2], { 'text-anchor': 'middle', 'font-size': 18, 'font-weight': 600, fill: p.tinta });
      L.crudo('</g>');
    }
    // los cinco puntos de avance
    for (i = 0; !limpio && i < PASOS.length; i++) {
      var activo = t >= PASOS[i][0] && (i + 1 === PASOS.length || t < PASOS[i + 1][0]);
      L.el('circle', { cx: W - 44 - (PASOS.length - 1 - i) * 16, cy: 44, r: activo ? 5 : 3.5, fill: activo ? p.acento : p.linea });
    }

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="El ciclo del PLA, átomo a átomo">' + L.s.join('') + '</svg>';
  }

  function montar(el) {
    var quieto = raiz.matchMedia && raiz.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = true, inicio = null;
    function oscuro() {
      var forzado = document.documentElement.getAttribute('data-theme');
      if (forzado) return forzado === 'dark';
      return raiz.matchMedia && raiz.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    function pinta(ahora) {
      if (inicio === null) inicio = ahora;
      if (visible) el.innerHTML = frame(quieto ? 18.8 : (ahora - inicio) / 1000, oscuro());
      if (!quieto) raiz.requestAnimationFrame(pinta);
    }
    if (raiz.IntersectionObserver) new IntersectionObserver(function (v) { visible = v[0].isIntersecting; }).observe(el);
    raiz.requestAnimationFrame(pinta);
  }

  var api = { frame: frame, montar: montar, duracion: T, pasos: PASOS };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else raiz.SugarCicloCiencia = api;
})(typeof window !== 'undefined' ? window : this);
